import { FC } from 'react';
import { useState } from 'react';
import classes from './BulkActionsBar.module.scss';
import { Button, Dropdown } from '@bphxd/ds-core-react';

export type StepInfo = {
  stepNo: number;
  stepTitle: string;
  phase: 'leak' | 'operational';
};

type Props = {
  selectedCount: number;
  onClearSelection: () => void;
  onExecuteStep: (step: StepInfo) => void;
};

const BulkActionsBar: FC<Props> = ({
  selectedCount,
  onClearSelection,
  onExecuteStep,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const hasSelection = selectedCount > 0;
  const toggle = () => {
    if (hasSelection) {
      setDropdownOpen((prev) => !prev);
    }
  };

  const bulkJointSigningSteps: StepInfo[] = [
    { stepNo: 5, stepTitle: 'Joint Checked', phase: 'leak' },
    { stepNo: 6, stepTitle: 'Service Test Start-up Date', phase: 'operational' },
    { stepNo: 7, stepTitle: '12 Hour Check', phase: 'operational' },
    { stepNo: 8, stepTitle: '24 Hour Check', phase: 'operational' },
    { stepNo: 9, stepTitle: '36 Hour Check', phase: 'operational' },
    { stepNo: 10, stepTitle: '48 Hour Check and Tag Removed', phase: 'operational' }
  ]

  const groupedSteps = {
    leak: bulkJointSigningSteps.filter((s) => s.phase === 'leak'),
    operational: bulkJointSigningSteps.filter((s) => s.phase === 'operational'),
  };

  return (
    <div className={classes.bulkActionsBar}>
      <div className={classes.content}>
        <span className={classes.label}>Bulk Joint Sign</span>

        <Dropdown
          isOpen={dropdownOpen}
          onToggleOpen={toggle}
          direction='down'
        >
          <Dropdown.Toggle
            caret
            color="dark"
            size="sm"
            disabled={!hasSelection}
            title={!hasSelection ? "Select one or more joints to execute steps in bulk" : ""}
          >
            Execute Step
          </Dropdown.Toggle>
          <Dropdown.Menu className={`${classes.dropdownMenu} dropdown-menu-scroll`}>
            <Dropdown.Item header>Leak/Service Test</Dropdown.Item>
            {groupedSteps.leak.map((step) => (
              <Dropdown.Item key={step.stepNo} onClick={() => onExecuteStep(step)}>
                {step.stepTitle}
              </Dropdown.Item>
            ))}
            <Dropdown.Item divider />
            <Dropdown.Item header>Operational Phase</Dropdown.Item>
            {groupedSteps.operational.map((step) => (
              <Dropdown.Item key={step.stepNo} onClick={() => onExecuteStep(step)}>
                {step.stepTitle}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <span className={`${classes.selectedCount} ${!hasSelection ? classes.noSelection : ''}`}>
          {selectedCount} joint{selectedCount !== 1 ? 's' : ''} selected
        </span>

        <Button
          color="link"
          size="sm"
          onClick={onClearSelection}
          className={classes.clearButton}
          disabled={!hasSelection}
        >
          Clear Selection
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsBar;
